import { SourceObject } from "@react-pdf/types";

export const makeImageSrcObject = (srcUri: string): SourceObject => ({
  uri: srcUri + `?no-cache=${new Date().getTime()}`,
  method: "GET",
  body: "",
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});
